import React from "react";
import {GrLinkedin} from 'react-icons/gr';
import {FaTwitter} from 'react-icons/fa';
import {BsGithub} from 'react-icons/bs';
import {BsInstagram} from 'react-icons/bs';

function Footer(){
    return(
        <footer>
            <a href="#" className='footer_logo'>Ashiq</a>
            <ul className="permalinks">
                <li><a href="#">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#skills">Skills</a></li>
                <li><a href="#experience">Experience</a></li>
                <li><a href="#contact">Contact</a></li>
            </ul>

            <div className="footer_socials">
                <a href="https://www.linkedin.com/in/ashiqnoorsudheer/" target="_blank"><GrLinkedin/></a>
                <a href="https://twitter.com/ashiq_n_sudheer" target="_blank"><FaTwitter/></a>
                <a href="https://github.com/AshiqNoor-S" target="_blank"><BsGithub/></a>
                <a href="https://www.linkedin.com/in/ashiqnoorsudheer/" target="_blank"><BsInstagram/></a>
            </div>

            <div className="footer_copyright">
                <small>&copy; Ashiq Noor </small>
            </div>
        </footer>
    );
}

export default Footer;